import React from 'react';
import { QuestionCardContainer } from '../../containers/QuestionCardContainer/QuestionCardContainer';
import { IQuestionCardPageProps } from './QuestionCardPage.types';

const QuestionCardPage: React.FC<IQuestionCardPageProps> = ({ match }: IQuestionCardPageProps) => {
  return <QuestionCardContainer routeParams={match.params} />;
};

export default QuestionCardPage;
